import React from 'react';
import { useLab } from '../../contexts/LabContext';

const LearningPath = () => {
    const { labData, currentSection } = useLab();

    if (!labData || !labData.sub_instructions) {
        return (
            <div style={styles.container}>
                <h4 style={styles.title}>🗺️ Learning Path</h4>
                <p style={styles.noData}>No learning path available</p>
            </div>
        );
    }

    const currentIndex = labData.sub_instructions.findIndex(
        sub => sub.sub_instruction_id === currentSection?.sub_instruction_id
    );

    return (
        <div style={styles.container}>
            <h4 style={styles.title}>🗺️ Learning Path</h4>
            <div style={styles.pathContainer}>
                {labData.sub_instructions.map((subInstruction, index) => {
                    const isCompleted = index < currentIndex;
                    const isCurrent = index === currentIndex;
                    const isUpcoming = index > currentIndex;

                    return (
                        <div key={subInstruction.sub_instruction_id} style={styles.stepContainer}>
                            <div style={styles.stepHeader}>
                                <div style={{
                                    ...styles.stepIndicator,
                                    ...(isCompleted && styles.completedIndicator),
                                    ...(isCurrent && styles.currentIndicator),
                                    ...(isUpcoming && styles.upcomingIndicator)
                                }}>
                                    {isCompleted ? '✅' : isCurrent ? '🔄' : (index + 1)}
                                </div>
                                <div style={styles.stepInfo}>
                                    <div style={{
                                        ...styles.stepTitle,
                                        ...(isCurrent && styles.currentStepTitle)
                                    }}>
                                        Step {index + 1}
                                    </div>
                                    <div style={styles.stepDescription}>
                                        {subInstruction.sub_instruction_description || 'Lab Step'}
                                    </div>
                                </div>
                            </div>
                            {index < labData.sub_instructions.length - 1 && (
                                <div style={{
                                    ...styles.connector,
                                    ...(isCompleted && styles.completedConnector)
                                }} />
                            )}
                        </div>
                    );
                })}
            </div>

            <div style={styles.progressContainer}>
                <div style={styles.progressLabel}>
                    Progress: {currentIndex + 1}/{labData.sub_instructions.length}
                </div>
                <div style={styles.progressBar}>
                    <div
                        style={{
                            ...styles.progressFill,
                            width: `${((currentIndex + 1) / labData.sub_instructions.length) * 100}%`
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: {
        backgroundColor: '#2d3748',
        border: '1px solid #4a5568',
        borderRadius: '8px',
        padding: '16px',
        margin: '16px 0',
    },
    title: {
        color: '#e2e8f0',
        margin: '0 0 16px 0',
        fontSize: '16px',
        fontWeight: '600',
    },
    noData: {
        color: '#a0aec0',
        fontStyle: 'italic',
        textAlign: 'center',
        padding: '20px',
    },
    pathContainer: {
        marginBottom: '16px',
    },
    stepContainer: {
        position: 'relative',
        marginBottom: '8px',
    },
    stepHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },
    stepIndicator: {
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        fontWeight: 'bold',
        flexShrink: 0,
    },
    completedIndicator: {
        backgroundColor: '#48bb78',
        color: 'white',
    },
    currentIndicator: {
        backgroundColor: '#4299e1',
        color: 'white',
        border: '2px solid #63b3ed',
    },
    upcomingIndicator: {
        backgroundColor: '#4a5568',
        color: '#a0aec0',
        border: '1px solid #718096',
    },
    stepInfo: {
        flex: 1,
    },
    stepTitle: {
        color: '#e2e8f0',
        fontSize: '14px',
        fontWeight: '500',
        marginBottom: '2px',
    },
    currentStepTitle: {
        color: '#63b3ed',
        fontWeight: '600',
    },
    stepDescription: {
        color: '#a0aec0',
        fontSize: '12px',
        lineHeight: '1.4',
    },
    connector: {
        position: 'absolute',
        left: '15px',
        top: '32px',
        width: '2px',
        height: '16px',
        backgroundColor: '#4a5568',
    },
    completedConnector: {
        backgroundColor: '#48bb78',
    },
    progressContainer: {
        marginTop: '16px',
        paddingTop: '16px',
        borderTop: '1px solid #4a5568',
    },
    progressLabel: {
        color: '#e2e8f0',
        fontSize: '14px',
        marginBottom: '8px',
        textAlign: 'center',
    },
    progressBar: {
        width: '100%',
        height: '8px',
        backgroundColor: '#4a5568',
        borderRadius: '4px',
        overflow: 'hidden',
    },
    progressFill: {
        height: '100%',
        backgroundColor: '#4299e1',
        transition: 'width 0.3s ease',
        borderRadius: '4px',
    },
};

export default LearningPath;
